import { receiptBasePdf } from './receiptBasePdf';
import { PDFDocument } from 'pdf-lib';
import { getFontsForReceipt } from '../../utils/getFont';
import { receiptData } from '../../types/receiptData';

export const receiptPdf = async (data: receiptData) => {
  const fonts = await getFontsForReceipt();
  const receipt = data;
  // 初回読み込みの容量を減らすため動的インポート
  const basePdf = await import('../../assets/base_receipt_pdf');

  //base page
  const page1: Uint8Array = await receiptBasePdf(
    receipt,
    fonts,
    basePdf.basePdf
  );
  const pdfDoc1 = await PDFDocument.load(page1);
  const mergedPdf = await PDFDocument.create();

  // base pageを追加
  const copiedPage1 = await mergedPdf.copyPages(
    pdfDoc1,
    pdfDoc1.getPageIndices()
  );
  copiedPage1.forEach(page => {
    mergedPdf.addPage(page);
  });

  // 控えも表示する場合
  if (data.receipt_copy_enabled) {
    const basePdf_copy = await import('../../assets/base_receipt_pdf_copy');
    const page2: Uint8Array = await receiptBasePdf(
      receipt,
      fonts,
      basePdf_copy.basePdf
    );
    const pdfDoc2 = await PDFDocument.load(page2);
    const copiedPage2 = await mergedPdf.copyPages(
      pdfDoc2,
      pdfDoc2.getPageIndices()
    );
    copiedPage2.forEach(page => {
      mergedPdf.addPage(page);
    });
  }

  const exportPdf = await mergedPdf.save();

  return new Blob([exportPdf], { type: 'application/pdf' });
};
